export const SUPPORT_EMAIL = "MA_Techsupport@moodys.com";
export const UNAUTHORIZED = "UNAUTHORIZED";
export const INCORRECT_LOGIN = "Incorrect username or password.";

export const DEBOUNCE_DELAY = 500;
export const ALERT_BANNER_TIMEOUT = 5000;

export const SPREAD = {
  FINANCIAL_TEMPLATE: {
    TOTAL_ASSET_DEFAULT_LABEL: "TOTAL ASSETS",
    TOTAL_ASSET_ID: "c_totalassets_bs",
    TOTAL_LIAL_AND_NET_DEFAULT_LABEL: "TOTAL LIABS & NET WORTH",
    TOTAL_LIAL_AND_NET_ID: "c_totalliabsnetworth_bs",
    TOTAL_ASSETS_ID: "c_totalassets_bs",
    TOTAL_LIABILITIES_AND_NET_WORTH_ID: "c_totalliabilitiesequity_bs",
    NET_PROFIT_DEFAULT_LABEL: "Net Profit",
    ENDING_CASH: "ENDING CASH"
  }
};

export const ERRORS = {
  PDF_READ_ERROR: "PDF_READ_ERROR",
  SPREAD_DELETED_MESSAGE: "This document no longer exists in QUIQspread",
  SPREAD_REJECTED_MESSAGE: "This document is rejected."
};

export const EXCEPTIONS = {
  NET_PROFIT_ID: "c_netprofit_is",
  SHEET_NAME: "INCOME_STATEMENT"
};

export const CASH_EXCEPTIONS = {
  ENDING_CASH_ID: "c_netincdecincashequivalent_cf",
  SHEET_NAME: "CASH_FLOW"
};

export const FRACTION_DIGITS = 2;

export const WALKME_DEV_URL =
  "https://cdn.walkme.com/users/c6ddc59ea36145dfbced51543252d611/test/walkme_c6ddc59ea36145dfbced51543252d611_https.js";
export const WALKME_PROD_URL =
  "https://cdn.walkme.com/users/c6ddc59ea36145dfbced51543252d611/walkme_c6ddc59ea36145dfbced51543252d611_https.js";

export const MAPPING_TOGGLES_ENABLED_DEFAULT_VALUE = true;

export const DEFAULT_LANGUAGE = "english";

// spread upload date after which old audit logs feature won't be available
// should be replaced with config or ENV variables, will be decided later.
export const AUDIT_LOG_DATE = "2021-06-18 12:00:00";
export const AUDIT_LOG_DATE_FORMAT = "YYYY-MM-DD hh:mm:ss";



// WEBPACK FOOTER //
// ./src/constants.ts